import axios from '@/plugins/axios'
import { successResponse, errorResponse } from '@/plugins/axios/utils'
import { generateRandomString } from '~js/utils'
import firebaseConfig from '~js/firebase-config'
import webStorage from '../../../store/webStorage/helper'

const serverURL = process.env.BACKEND_URL

export function uploadPilotVideo (file, pilotId, type) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    const fileId = generateRandomString(10)
    // console.log('fileId', fileId)
    const fileName = `${pilotId}/${fileId}`
    const fileType = file.type.split(';')[0]
    let res = await getSignUrl(fileName, fileType)
    // console.log('getSignUrl', res)
    if (!res.success) {
      resolve('')
    }
    const signUrl = res.data.signUrl
    res = await uploadGCP(signUrl, file, fileType)
    // console.log('uploadGCP', res)
    if (!res.success) {
      resolve('')
    }
    const uploadedUrl = `https://storage.googleapis.com/${firebaseConfig.storageBucketConvertMP3}/${fileName}`
    resolve(uploadedUrl)
  })
}

function getSignUrl (fileName, fileType) {
  return axios.get(`${serverURL}/v2/credential/gcsConvertMP3SignUrl?fileName=${fileName}&contentType=${fileType}`, {
    headers: {
      'istaging-token-type': 'istaging',
      'istaging-token': webStorage.getItem(`session-token-${process.env.NODE_ENV}`)
    }
  })
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}

function uploadGCP (url, file, fileType) {
  return axios.put(url, file, {
    headers: {
      'content-type': fileType
    }
  })
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}
